import { nodeListToArray } from '../helpers/nodeListToArray';

const ON = "on";
const TRUE = 'true';
const FALSE = 'false';
const RADIO_CLASS = "form-element-radio";
const CHECKBOX_CLASS = "form-element-checkbox";

export function initializeRadioAndCheckboxFocus() {
    var radios = nodeListToArray(document.querySelectorAll(`.${RADIO_CLASS}`));
    if (radios != null) {
        [].forEach.call(radios, (radio) => {
            (radio as HTMLElement).addEventListener("keypress", (e) => {
                if (e.charCode == 13 || e.charCode == 32) {
                    ((radio as HTMLElement).querySelector("input[type=radio]") as any).checked = !((radio as HTMLElement).querySelector("input[type=radio]") as any).checked;
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            (radio as HTMLElement).addEventListener("click", () => {
                let input: HTMLInputElement = radio.querySelector('input[type=radio]');
                if (input && !input.disabled) {
                    input.checked = true;
                }
            });
        });
    }

    var checkboxes = nodeListToArray(document.querySelectorAll(`.${CHECKBOX_CLASS}`));
    if (checkboxes != null) {
        [].forEach.call(checkboxes, (checkbox) => {
            // Need to convert 'on' values to true / false for proper mvc posting
            if (!checkbox.value || (checkbox.value === ON && checkbox.checked !== true)) {
                checkbox.value = FALSE;
            }
            else if (checkbox.checked === true) {
                checkbox.value = TRUE;
            }

            (checkbox as HTMLElement).addEventListener("keypress", (e) => {
                if (e.charCode == 13 || e.charCode == 32) {
                    ((checkbox as HTMLElement).querySelector("input[type=checkbox]") as any).checked = !((checkbox as HTMLElement).querySelector("input[type=checkbox]") as any).checked;
                    e.preventDefault();
                    e.stopPropagation();
                }
            });

            (checkbox as HTMLElement).addEventListener('change', (e) => {
                toggleCheckbox(e);
            });
        });
    }
}

var toggleCheckbox = (e) => {
    // Need to convert 'on' values to true / false for proper mvc posting
    var element = e.currentTarget as any;
    if (element.value === ON || element.value === TRUE) {
        element.value = FALSE;
    }
    else if (!element.value || element.value === FALSE) {
        element.value = TRUE;
    }
    e.preventDefault();
    e.stopPropagation();
}